import React from 'react'
import { Redirect } from 'react-router-dom'
import HeadTitle from 'front-end/src/components/common/head/HeadTitle'
import { t } from '@lingui/macro'
import { HomepageBanner } from 'front-end/src/pages/manage-campaign-page/components/homepage-banner/HomepageBanner'
import { SharedWithMe } from 'front-end/src/pages/home-page/components/shared-with-me/SharedWithMe'
import { UpcomingEventsRow } from 'front-end/src/pages/manage-events/components/upcoming-events-row/UpcomingEventsRow'
import { YourCertifications } from 'front-end/src/pages/home-page/components/your-certifications/YourCertifications'
import YourPathways from 'front-end/src/pages/home-page/components/your-pathways/YourPathways'
import { YourWorkspaces } from 'front-end/src/pages/home-page/components/your-workspaces/YourWorkspaces'
import { RecentlyViewedTopics } from 'front-end/src/pages/home-page/components/recently-viewed/RecentlyViewedTopics'

export const HomePage = ({
  isCertificatesDisabled
}: {
  isCertificatesDisabled: boolean
}) => {
  if (sessionStorage.getItem('persistentUrl')) {
    const redirectUrl = sessionStorage.getItem('persistentUrl')
    sessionStorage.removeItem('persistentUrl')
    return <Redirect to={redirectUrl as string} />
  }
  return (
    <div className="panel dashboard">
      <HeadTitle title={t`Home`} />
      <div className="panel-content" tabIndex={-1}>
        <HomepageBanner />
        <SharedWithMe topicEnrolmentLimit={4} />
        <UpcomingEventsRow />
        {!isCertificatesDisabled && <YourCertifications />}
        <YourPathways />
        <YourWorkspaces />
        <RecentlyViewedTopics />
      </div>
    </div>
  )
}
